// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__9wgBy","container":"styles_container__1tKn3","title":"styles_title__2CdFI","wrapper":"styles_wrapper__3odwP","answer":"styles_answer__1jLHk"};